// Centralized blog posts data - used by BlogIndex and sitemap generator
// Source of truth: src/data/blogPosts.json
import blogPostsData from './blogPosts.json';

export const blogPosts = blogPostsData;

// Static routes configuration
export const staticRoutes = [
  {
    path: "/",
    priority: "1.0",
    changefreq: "weekly",
  },
  {
    path: "/services",
    priority: "0.9",
    changefreq: "weekly",
  },
  {
    path: "/wavenotify",
    priority: "0.95",
    changefreq: "weekly",
  },
  {
    path: "/wavesync",
    priority: "0.95",
    changefreq: "weekly",
  },
  {
    path: "/contact",
    priority: "0.8",
    changefreq: "monthly",
  },
  {
    path: "/blog",
    priority: "0.8",
    changefreq: "weekly",
  },
  {
    path: "/privacy",
    priority: "0.6",
    changefreq: "yearly",
  },
];

